/**
 * A sidebar filter box with a datalist of suggestions and a clear button.
 *
 * Its own component because both dealer dashboards render it twice — city and
 * dealer name — and in the Razor markup that was the same block four times over.
 * That duplication is what let the Takata dealer box rot: it had the markup but
 * no event listener, and its clear button was caught by a `.clear-filter-btn`
 * selector that cleared the city box instead.
 */
export interface DealerTextFilterProps {
  id: string;
  label: string;
  placeholder: string;
  clearTitle: string;
  /** Datalist element id; must be unique within the page. */
  listId: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export function DealerTextFilter({
  id,
  label,
  placeholder,
  clearTitle,
  listId,
  options,
  value,
  onChange,
}: DealerTextFilterProps) {
  return (
    <div className="filter-group">
      <label htmlFor={id}>{label}</label>
      <input
        type="text"
        id={id}
        list={listId}
        placeholder={placeholder}
        autoComplete="off"
        className="city-autocomplete-input"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') onChange('');
        }}
      />
      <datalist id={listId}>
        {options.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
      <button
        type="button"
        className={`clear-filter-btn${value.length > 0 ? ' visible' : ''}`}
        title={clearTitle}
        aria-label={clearTitle}
        onClick={() => onChange('')}
      >
        ×
      </button>
    </div>
  );
}
